import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';

import { redirectus } from 'ggApp/modules/router/actions';
import { storeActive as storeActiveSelector } from 'ggApp/modules/store/selectors';
import { preorderProductsFromFeatureFlag as preorderProductsFromFeatureFlagSelector } from 'ggApp/modules/featureFlag';

import Confirmation from './Confirmation';

const enhanced = compose(
    connect(
        createStructuredSelector({
            activeStore: storeActiveSelector,
            preorderProducts: preorderProductsFromFeatureFlagSelector,
        }),
        (dispatch) => ({
            redirectus: bindActionCreators(redirectus, dispatch),
        }),
    ),
)(Confirmation);

export { enhanced as Confirmation };
